export default "__VITE_ASSET__73d44a31__"